import { authenticatedFetch } from "@lumi/data";
import { useEffect, useState } from "react";
import { useAuth } from "../../../auth/AuthContext";
import { createRefreshCallback } from "../../../auth/refreshCallback";

interface Collection {
  key: string;
  name: string;
  sort: number;
}

/**
 * Hook to fetch all collections
 */
export function useCollections() {
  const { accessToken, refreshAuth } = useAuth();
  const [collections, setCollections] = useState<Collection[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const API_BASE = import.meta.env.VITE_API_BASE_URL || "http://localhost:3333";

  useEffect(() => {
    if (!accessToken) {
      setLoading(false);
      return;
    }

    const fetchCollections = async () => {
      setLoading(true);
      setError(null);

      try {
        const url = `${API_BASE}/v1/collections`;

        const response = await authenticatedFetch<Collection[]>(
          url,
          { method: "GET" },
          accessToken,
          createRefreshCallback(refreshAuth),
        );

        setCollections(response);
      } catch (err) {
        console.error("Failed to fetch collections:", err);
        setError(err instanceof Error ? err.message : "Failed to fetch collections");
      } finally {
        setLoading(false);
      }
    };

    void fetchCollections();
  }, [accessToken, refreshAuth, API_BASE]);

  return { collections, loading, error, count: collections.length };
}
